<!-- ================管理端-教研赛事====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">教研赛事列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">创建赛事</div>
            <div class="admin-btn-item" @click="handleScaleAdd">竞赛评审量表</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">竞赛状态:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.status" placeholder="请选择">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.name" placeholder="请输入竞赛名称">
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="竞赛状态" prop="status">
                    <template #default="scope">
                        <div v-if="scope.row.status === 0">初始阶段</div>
                        <div v-if="scope.row.status === 1">报名阶段</div>
                        <div v-if="scope.row.status === 2">初审阶段</div>
                        <div v-if="scope.row.status === 3">复审阶段</div>
                        <div v-if="scope.row.status === 4">终审阶段</div>
                        <div v-if="scope.row.status === 5">现场评比</div>
                        <div v-if="scope.row.status === 6">竞赛结束</div>
                    </template>
                </el-table-column>
                <el-table-column width="220" align="center" label="竞赛名称" prop="raceName">
                    <template #default="scope">
                        <div :title="scope.row.raceName" @click="goDetail(scope.row)" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.raceName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="center" label="竞赛级别" prop="raceLevelName" />
                <el-table-column width="120" align="center" label="审核模式" prop="checkModeName" />
                <el-table-column width="260" align="center" label="报名阶段" prop="time">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="180" align="center" label="学段·年级·学科">
                    <template #default="scope">
                        <el-text>
                            {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column width="120" fixed="right" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="100" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item" v-if="scope.row.status != 6 && (scope.row.isCreate || role == 1 || role == 2)">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item" v-if="role == 1 || role == 2 || userId == scope.row.raceLeader">
                                        <el-text type="primary" @click="handleManager(scope.row)">管理</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status == 0">
                                        <el-text type="primary" @click="handleRelease(scope.row)">发布</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status != 0 && scope.row.status != 6">
                                        <el-text type="primary" @click="handleStop(scope.row)">停止</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                            confirm-button-text="是"
                                            cancel-button-text="否"
                                            icon-color="#626AEF"
                                            title="确定删除该赛事?"
                                            @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page="queryParams.pageNum"
                        v-model:limit="queryParams.pageSize"
                        @pagination="getList" />
        </div>
    </div>

</template>
<script>
// 列表页核心接口在 race.js；eduScale.js、raceSign.js 在同模块的量表/报名审核页面使用
import { classRacePage, raceRelease, raceStop, raceDelete } from "@/api/admin/race";
import { timestampToTime } from "@/utils/date";
import { queryDict } from "@/api/admin/dict";

export default {
    components: {},
    name: "raceIndex",
    data() {
        return {
            timestampToTime,
            role: this.$storage.get("role"),
            userId: '',
            loading: false,
            total: 0,
            dataList: [],
            queryParams: {
                name: '',
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: '',
                nature: '',
                pageNum: 1,
                pageSize: 10,
            },
            statusList: [
                { name: '初始阶段', value: 0 },
                { name: '报名阶段', value: 1 },
                { name: '初审阶段', value: 2 },
                { name: '复审阶段', value: 3 },
                { name: '终审阶段', value: 4 },
                { name: '现场评比', value: 5 },
                { name: '竞赛结束', value: 6 },
            ],
            natureList: [],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.initUserId();
        this.getQueryDict();
        this.getList();
    },
    mounted() {},
    methods: {
        initUserId() {
            const userInfo = this.$storage.get("userInfo");
            if (userInfo) {
                try {
                    this.userId = JSON.parse(userInfo).userId;
                } catch (e) {
                    this.userId = '';
                }
            }
        },
        getQueryDict() {
            queryDict({ code: 'activity_nature' }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.natureList = res.data.data;
                }
            })
        },
        /** 查询赛事列表 */
        getList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            classRacePage(this.queryParams).then(res => {
                if (res.data && res.data.code == 1) {
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置查询条件 */
        resetQuery() {
            this.queryParams = {
                name: '',
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: '',
                nature: '',
                pageNum: 1,
                pageSize: 10,
            };
            this.getList();
        },
        /** 创建赛事 */
        handleCreate() {
            this.$router.push({
                path: "/raceCreate",
            });
        },
        /** 编辑赛事 */
        handleUpdate(row) {
            this.$router.push({
                path: "/raceCreate",
                query: {
                    raceId: row.raceId,
                }
            });
        },
        /** 赛事详情 */
        goDetail(row) {
            this.$router.push({
                path: "/raceDetail",
                query: {
                    raceId: row.raceId,
                }
            });
        },
        /** 竞赛管理 */
        handleManager(row) {
            this.$router.push({
                path: "/raceManager",
                query: {
                    raceId: row.raceId,
                }
            });
        },
        /** 竞赛评审量表 */
        handleScaleAdd() {
            this.$router.push({
                path: "/raceScale",
            });
        },
        /** 发布赛事 */
        handleRelease(row) {
            this.$confirm('确定发布该赛事?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                raceRelease({ raceId: row.raceId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success("发布成功");
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || "发布失败");
                    }
                })
            });
        },
        /** 停止赛事 */
        handleStop(row) {
            this.$confirm('确定停止该赛事?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                raceStop({ raceId: row.raceId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success("停止成功");
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || "停止失败");
                    }
                })
            });
        },
        /** 删除赛事 */
        handleDelete(row) {
            raceDelete({ raceId: row.raceId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "删除失败");
                }
            })
        },
    },
}
</script>
<style scoped>
.name-search-btn {
    background-color: #377f7f !important;
    color: #fff !important;
}
</style>
